import {useState, useEffect, useMemo} from 'react'
import {useLocation, useParams} from 'react-router-dom'

const fromPathname = (pathname, params) => {
  const pathParts = pathname.split('/').filter(x => !!x)
  const isRoot = pathParts.length <= 1
  const firstPart = pathParts[0]
  const lastPart = pathParts[pathParts.length - 1]
  let contextualUserId
  const isAusbildungsplan = pathParts.includes('ausbildungsplan')
  if (isAusbildungsplan) {
    contextualUserId = parseInt(params.azubiId, 10)
  }

  const isStaticContent = isAusbildungsplan && pathParts.includes('static')
  const isQuestionsContent = isAusbildungsplan && pathParts.includes('questions')
  return {
    pathname,
    isRoot,
    pathParts,
    firstPart,
    lastPart,
    contextualUserId,
    isStaticContent,
    isQuestionsContent,
  }
}

const toTrimmedLowerCase = t => t.trim().toLowerCase()

export const useNavigationState = () => {
  const location = useLocation()
  const params = useParams()
  const [pathname, setPathname] = useState(toTrimmedLowerCase(location.pathname))

  useEffect(() => {
    setPathname(toTrimmedLowerCase(location.pathname))
  }, [location])
  return useMemo(() => fromPathname(pathname, params), [pathname])
}
